import React from 'react';
import { motion } from 'framer-motion';
import Constants from '../../../app/utils/constants';
import cryptonaryOverviewPhoneImage from '../../../assets/images/cryptonary/overview_phone.webp';
import cryptonaryOverviewCoinImage from '../../../assets/images/cryptonary/coin.webp';
import colors from '../../theme/color';

const OverviewSection = () => {
  const { cryptonaryOverviewSectionDescription } = Constants;

  return (
    <section className="relative mt-10 md:mt-0 z-20 w-full overflow-hidden pt-4 pb-12 md:pt-6 md:pb-16 lg:pt-8 lg:pb-20 2xl:pt-10 2xl:pb-28 min-[2560px]:pt-14 min-[2560px]:pb-48">
      <div
        className="pointer-events-none absolute -right-44 top-[8%] hidden h-[640px] w-[500px] rounded-full opacity-[0.10] blur-3xl md:block"
        style={{ backgroundColor: colors.cryptonaryGlowPrimary }}
      />
      <div
        className="pointer-events-none absolute -right-20 top-[24%] hidden h-[420px] w-[340px] rounded-full opacity-[0.30] blur-[120px] lg:block"
        style={{ backgroundColor: colors.cryptonaryGlowSecondary }}
      />

      <div className="w-full px-4 md:px-6 lg:px-6 xl:px-8 2xl:px-12 min-[1800px]:px-16 min-[2200px]:px-24 min-[2560px]:px-24">
      <div className="grid items-center gap-8 md:grid-cols-[42%_minmax(0,1fr)] md:gap-8 lg:grid-cols-[40%_minmax(0,1fr)] xl:gap-12 2xl:gap-16 min-[1800px]:gap-20 min-[2200px]:gap-24 min-[2560px]:gap-20">
          <motion.div
           className="relative mx-auto w-full shrink-0 md:mx-0 md:w-full lg:w-[36vw] min-[1800px]:w-[40vw] min-[2200px]:w-[44vw]"
            initial={{ opacity: 0, y: 42 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.35 }}
            transition={{ duration: 1.55, ease: [0.22, 1, 0.36, 1] }}
          >
            <motion.img
              src={cryptonaryOverviewCoinImage}
              alt="Floating Ethereum coin"
              className="pointer-events-none absolute left-[18%] top-[4%] z-20 w-[15%] md:w-[22%] min-w-[90px] object-contain min-[1800px]:min-w-[120px] min-[2200px]:min-w-[150px]"
              style={{ filter: `drop-shadow(0 18px 34px ${colors.cryptonaryOverviewCoinGlow}6B)`, transformPerspective: 1400 }}
              animate={{
                y: [0, -8, 0],
                x: [0, 5, 0, -4, 0],
                rotateY: [0, 180, 360],
                rotateX: [0, 10, 0],
                scale: [1, 1.14, 1],
                rotate: [0, 2, 0],
              }}
              transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut' }}
            />
           <motion.img
  src={cryptonaryOverviewPhoneImage}
  alt="Cryptonary mobile app overview screens"
  className="relative z-10 h-auto mx-auto w-[70%] md:w-full max-w-full object-contain lg:w-auto lg:max-w-full"
  animate={{
    y: [0, -10, 0],
    rotate: [-3, 3, -3],
  }}
  transition={{
    duration: 7,
    repeat: Infinity,
    ease: 'easeInOut',
  }}
/>
          </motion.div>

          <motion.div className="relative min-w-0 text-center md:text-start w-full md:w-full lg:ml-auto lg:w-[48vw] min-[1800px]:w-[44vw] min-[2200px]:w-[40vw]"
            initial={{ opacity: 0, x: 70 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: false, amount: 0.4 }}
            transition={{ duration: 1.45, ease: [0.22, 1, 0.36, 1] }}
          >
            <motion.h2
              className="font-gilroy-extrabold text-[2.2rem] leading-[1.04] tracking-[-0.01em] sm:text-[2.6rem] md:text-[2.5rem] lg:text-[3.6rem] 2xl:text-[4.8rem] min-[1800px]:text-[5.4rem] min-[2200px]:text-[6.4rem] min-[2560px]:text-[8rem]"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.4 }}
              transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1], delay: 0.12 }}
            >
              <span style={{ color: colors.cryptonaryAccentGreen }}>Overview</span>
              <br />
              <span className="text-white">of the Platform</span>
            </motion.h2>

            <motion.p
              className="mt-5 w-full opacity-75 font-gilroy-medium text-[1rem] leading-[1.45] sm:text-[1.06rem] md:text-[1.08rem] lg:text-[1.12rem] 2xl:text-[1.6rem] min-[1800px]:text-[1.75rem] min-[2200px]:text-[1.95rem]"
              style={{ color: colors.cryptonaryTextOverviewBody }}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 0.75, y: 0 }}
              viewport={{ once: false, amount: 0.4 }}
              transition={{ duration: 1.3, ease: [0.22, 1, 0.36, 1], delay: 0.3 }}
            >
              {cryptonaryOverviewSectionDescription}
            </motion.p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default OverviewSection;
